module.exports = __webpack_public_path__ + "img/virtuzone.5e587397.png";